@if (isAIThinking) {
  <div class="modal">
    <div class="modal-dialog-content">
      <p>Please wait, while AI is thinking.</p>
    </div>
  </div>
}
<div class="m-3 section">
  <div class="title-section w-100">
    <p class="lead">
      Pick request for AI assistant
    </p>
    <button id="close" type="button" class="btn my-btn noborder" (click)="close()" data-bs-toggle="tooltip" data-bs-placement="top" title="Close window" data-bs-delay="{show: 1000}" >
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
  <div class="m-2 btn-group">
    @for (action of prefixes; track action) {
      <a (click)="generateCompletion(action.prefix)" type="button" class="btn my-btn my-1">
        {{action.action}}
      </a>
    }
  </div>
  <div class="m-2">
    Type your propmpt here:
    <textarea type="text" class="form-control textarea" [(ngModel)]="prompt" (keyup.enter)="generateCompletion(prompt)"></textarea>
    <button id="generate" type="button" class="btn my-btn my-1" (click)="generateCompletion(prompt)">Send</button>
  </div>
  @if (completionGenerated == true) {
    <div class="mt-5">
      <p class="lead">
        Generated answer
      </p>
      <p class="my-1 small">
        {{completion}}
      </p>
    </div>
  }
  <div class="m-1 btn-group">
    @if (completionGenerated == true && isReadOnly == false) {
      <button id="save" type="button" class="btn my-btn" (click)="save()" data-bs-toggle="tooltip" data-bs-placement="top" title="Add generated content" data-bs-delay="{show: 1000}">
        <i class="bi bi-save"></i>
      </button>
    }
  </div>
</div>


